import styled from "styled-components"

import { eq, minWidth } from "utils"

export const Wrapper = styled.div`
  position: relative;
  width: calc(100% - 5.4rem);
  margin: 0 2.7rem 2rem;
  background-color: #efeee9;
  ::after {
    content: "";
    position: absolute;
    bottom: -2px;
    left: 0;
    right: 0;
  }

  ${minWidth.tablet`
    max-width: 58rem;
    margin: 0 auto 4rem;
    width: auto;
  `}

  ${minWidth.hamburgerLarge`
    max-width: 72.5rem;

    ${eq("isFeatured", false)`
      margin-left: 0;
    `}
  `}
`

export const List = styled.div`
  padding: 1rem 1.2rem;
  transition: height 0.3s ease-out;
`

export const Item = styled.a``

export const ItemText = styled.span`
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 1.6rem;
  color: #222222;
  font-weight: 400;
  line-height: 2rem;
  text-decoration: underline;
  transition: color 0.15s linear;
  line-height: 3rem;

  ${Item}:hover & {
    color: #b5471f;
  }
`

export const ItemSeparator = styled.div`
  border: 0.1rem solid #bcb7b9;
  background-color: #bcb7b9;
  height: 1.6rem;
  width: 0.1rem;
  display: inline-block;
  position: relative;
  top: 0.3rem;
  margin: 0 1.2rem;
`
